import {
  // forms
  AbastecimentoForm,
  AdmSisarePassengerForm,
  AgendaEscalaFornecedorForm,
  AtendimentoSACForm,
  CanalVendaForm,
  CategoriaServicoForm,
  ClassificacaoForm,
  ClienteForm,
  ContaCorrenteForm,
  ContatoForm,
  FechamentoFinanceiroForm,
  FollowUpForm,
  FollowUpHistorico,
  FormPax,
  GrupoContatoForm,
  HistoricoBancarioForm,
  MarcaVeiculoForm,
  ModeloVeiculoForm,
  MotivoCancelamentoForm,
  OpcionalVeiculoForm,
  OSForm,
  OsManutVeiculoForm,
  PermissoesForm,
  ServicoForm,
  SubclassificacaoForm,
  TipoDocumentoForm,
  TipoVeiculoForm,
  UsuarioForm,
  UsuarioPartnerForm,
  VeiculoForm,
  VendedorForm,

  // lists
  AbastecimentoList,
  AdmSisarePassengerList,
  AgendaEscalaFornecedorList,
  AtendimentoSACList,
  BancoList,
  CanalVendaList,
  CategoriaServicoList,
  ClassificacaoList,
  ClienteList,
  ContaCorrenteList,
  ContatoList,
  FeriadoList,
  FollowUpList,
  HistoricoBancarioList,
  GrupoContatoList,
  MarcaVeiculoList,
  ModeloVeiculoList,
  MotivoCancelamentoList,
  OpcionalVeiculoList,
  OSList,
  OsManutVeiculoList,
  PaisList,
  ServicoList,
  SetorList,
  SubclassificacaoList,
  TipoDocumentoList,
  TipoVeiculoList,
  TransacaoFinanceiraList,
  UsuarioList,
  UsuarioPartnerList,
  VeiculoList,
  VendedorList,

  // outros
  AdmSisarePassengerAnalytics,
  Dashboard,
  FaleConosco,
  Hospedagem,
  Login,
  LoginAppCli,
  LoginPartner,
  Logout,
  MapaOperacao,
  MenuAdministrativo,
  MenuFinanceiro,
  MenuOperacional,
  MenuProducao,
  MenuProgramacao,
  OrbitIntegration,
  WhatsAppChat,
  SolicitacoesPdv,
  ConfiguracaoGeralPdv
} from 'views';
import {
  AMODULO_ADMAPPCLI,
  AMODULO_CRM,
  AMODULO_ESTOQUE,
  AMODULO_FINANCAS,
  AMODULO_FRONT,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_PDVMOVEL,
  AMODULO_PARTNER
} from 'consts';
import {
  Main as MainLayout,
  Minimal as MinimalLayout
} from 'layouts';
import {
  AccountBalanceOutlined,
  AccountCircleOutlined,
  AccountTreeOutlined,
  AssessmentOutlined,
  AssignmentIndOutlined,
  AssignmentOutlined,
  AssignmentTurnedInOutlined,
  BuildOutlined,
  CategoryOutlined,
  ChatBubbleOutlineOutlined,
  Commute,
  ContactsOutlined,
  DashboardOutlined,
  DescriptionOutlined,
  DriveEtaOutlined,
  EmojiTransportation,
  EventOutlined,
  EventNoteOutlined,
  ExitToAppRounded,
  FormatListBulletedRounded,
  ForumOutlined,
  Grain,
  HeadsetMicOutlined,
  InsertDriveFileOutlined,
  LocalGasStationOutlined,
  MessageOutlined,
  MonetizationOnOutlined,
  PeopleOutline,
  PermContactCalendarOutlined,
  PersonOutlined,
  PlaylistAddCheckRounded,
  PostAddRounded,
  Public,
  QueueOutlined,
  ReceiptOutlined,
  RecentActorsOutlined,
  Send,
  SettingsApplicationsOutlined,
  Storefront,
  SupervisedUserCircleOutlined,
  TextsmsOutlined,
  Timeline,
  TrendingUpRounded,
  ViewModuleRounded,
  ViewWeekRounded,
  WhatsApp,
  WidgetsOutlined
} from '@material-ui/icons';
import React from 'react';
import { PERMS } from 'permissions';
import { CommonTranslations } from 'translations/translationKeys';

/* Define as rotas, layouts, módulos e permissões da aplicação  */
export const appRoutes = [
  // geral
  {
    path: '/login',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/logout',
    exact: true,
    component: Logout,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // adm pdv movel
  {
    path: '/admpdvmovel',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admpdvmovel/solicitacoes-pdv',
    exact: true,
    component: SolicitacoesPdv,
    layout: MainLayout,
    moduleCode: AMODULO_PDVMOVEL,
    requiredPerm: PERMS.ADMPDVMOVEL_MENU_SOLICITACOES_PDV,
    authType: 'internal',
    redirectTo: '/admpdvmovel'
  },
  {
    path: '/admpdvmovel/configuracoes/geral',
    exact: true,
    component: ConfiguracaoGeralPdv,
    layout: MainLayout,
    moduleCode: AMODULO_PDVMOVEL,
    requiredPerm: PERMS.ADMPDVMOVEL_MENU_CONFIGURACOES_GERAL,
    authType: 'internal',
    redirectTo: '/admpdvmovel'
  },
  {
    path: '/admpdvmovel/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_PDVMOVEL,
    requiredPerm: PERMS.ADMPDVMOVEL_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpdvmovel'
  },
  {
    path: '/admpdvmovel/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_PDVMOVEL,
    requiredPerm: PERMS.ADMPDVMOVEL_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpdvmovel/usuario'
  },
  {
    path: '/admpdvmovel/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_PDVMOVEL,
    requiredPerm: PERMS.ADMPDVMOVEL_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpdvmovel/usuario'
  },

  // adm appcli
  {
    path: '/admappcli',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admappcli/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger/:id',
    exact: true,
    component: AdmSisarePassengerForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-list',
    exact: true,
    component: AdmSisarePassengerList,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-analytics',
    exact: true,
    component: AdmSisarePassengerAnalytics,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_PASSENGER_ANALYTIC,
    authType: 'internal'
  },
  {
    path: '/admappcli/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/admappcli/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admappcli/usuario'
  },
  {
    path: '/admappcli/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admappcli/usuario'
  },
  {
    path: '/admappcli/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/admappcli/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: PERMS.ADMAPPCLI_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/admappcli/cliente'
  },

  // appcli
  {
    path: '/appcli',
    exact: true,
    component: LoginAppCli,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/login',
    exact: true,
    component: LoginAppCli,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli/programacao',
    exact: true,
    component: MenuProgramacao,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/hospedagem',
    exact: true,
    component: Hospedagem,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/faleconosco',
    exact: true,
    component: FaleConosco,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/:localizador',
    exact: true,
    component: LoginAppCli,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // adm partner
  {
    path: '/admpartner',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admpartner/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'internal',
    redirectTo: '/admpartner'
  },
  {
    path: '/admpartner/usuariopartner',
    exact: true,
    component: UsuarioPartnerList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuariopartner/:id',
    component: UsuarioPartnerForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpartner/usuario'
  },
  {
    path: '/admpartner/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/admpartner/usuario'
  },
  {
    path: '/admpartner/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    // requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/admpartner/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    // requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/admpartner/cliente'
  },

  // partner
  {
    path: '/partner',
    exact: true,
    component: LoginPartner,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/partner/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorList,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'partner',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA,
    authType: 'partner',
    redirectTo: '/partner'
  },

  // crm
  {
    path: '/crm',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/crm/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/crm/chatwhatsapp',
    exact: true,
    component: WhatsAppChat,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/crm/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/crm/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/crm/usuario'
  },
  {
    path: '/crm/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/crm/usuario'
  },
  {
    path: '/crm/contato',
    exact: true,
    component: ContatoList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    //requiredPerm: PERMS.CRM_MENU_CADASTRO_CONTATO_AVULSO,
    authType: 'internal'
  },
  {
    path: '/crm/contato/:id',
    component: ContatoForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    //requiredPerm: PERMS.CRM_MENU_CADASTRO_CONTATO_AVULSO,
    authType: 'internal',
    redirectTo: '/crm/contato'
  },
  {
    path: '/crm/grupocontato',
    exact: true,
    component: GrupoContatoList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_GRUPO_CONTATO_AVULSO,
    authType: 'internal'
  },
  {
    path: '/crm/grupocontato/:id',
    component: GrupoContatoForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_GRUPO_CONTATO_AVULSO,
    authType: 'internal',
    redirectTo: '/crm/grupocontato'
  },
  {
    path: '/crm/canalvenda',
    exact: true,
    component: CanalVendaList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_CANAL_VENDA,
    authType: 'internal'
  },
  {
    path: '/crm/canalvenda/:id',
    component: CanalVendaForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_CANAL_VENDA,
    authType: 'internal',
    redirectTo: '/crm/canalvenda'
  },
  {
    path: '/crm/classifatendimentosac',
    exact: true,
    component: ClassificacaoList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_SAC_CLASSIFICACAO_ATENDIMENTO,
    authType: 'internal'
  },
  {
    path: '/crm/classifatendimentosac/:id',
    component: ClassificacaoForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_SAC_CLASSIFICACAO_ATENDIMENTO,
    authType: 'internal',
    redirectTo: '/crm/classifatendimentosac'
  },
  {
    path: '/crm/subclassifatendimentosac',
    exact: true,
    component: SubclassificacaoList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_SAC_SUBCLASSIFICACAO_ATENDIMENTO,
    authType: 'internal'
  },
  {
    path: '/crm/subclassifatendimentosac/:id',
    component: SubclassificacaoForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_SAC_SUBCLASSIFICACAO_ATENDIMENTO,
    authType: 'internal',
    redirectTo: '/crm/subclassifatendimentosac'
  },
  {
    path: '/crm/followup',
    exact: true,
    component: FollowUpList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_PROCEDIMENTOS_FOLLOW_UP,
    authType: 'internal'
  },
  {
    path: '/crm/followup/:id/historico',
    component: FollowUpHistorico,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_PROCEDIMENTOS_FOLLOW_UP,
    authType: 'internal',
    redirectTo: '/crm/followup'
  },
  {
    path: '/crm/followup/:id',
    component: FollowUpForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_PROCEDIMENTOS_FOLLOW_UP,
    authType: 'internal',
    redirectTo: '/crm/followup'
  },
  {
    path: '/crm/atendimentosac',
    exact: true,
    component: AtendimentoSACList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_PROCEDIMENTOS_ATENDIMENTO_SAC,
    authType: 'internal'
  },
  {
    path: '/crm/atendimentosac/:id',
    component: AtendimentoSACForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_PROCEDIMENTOS_ATENDIMENTO_SAC,
    authType: 'internal',
    redirectTo: '/crm/atendimentosac'
  },
  {
    path: '/crm/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/crm/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: PERMS.CRM_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/crm/cliente'
  },

  // estoque
  {
    path: '/estoque',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/estoque/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/estoque/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    requiredPerm: PERMS.ESTOQUE_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/estoque/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    requiredPerm: PERMS.ESTOQUE_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/estoque/usuario'
  },
  {
    path: '/estoque/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    requiredPerm: PERMS.ESTOQUE_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/estoque/usuario'
  },
  {
    path: '/estoque/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    // requiredPerm: PERMS.ESTOQUE_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/estoque/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_ESTOQUE,
    // requiredPerm: PERMS.ESTOQUE_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/estoque/cliente'
  },

  // finanças
  {
    path: '/financas',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/financas/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/financas/historicosbancarios',
    exact: true,
    component: HistoricoBancarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
    authType: 'internal'
  },
  {
    path: '/financas/historicosbancarios/:id',
    exact: true,
    component: HistoricoBancarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
    authType: 'internal'
  },
  {
    path: '/financas/historicosbancarios/:id/view',
    exact: true,
    component: HistoricoBancarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO,
    authType: 'internal'
  },
  {
    path: '/financas/tiposdocumentos',
    exact: true,
    component: TipoDocumentoList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/tiposdocumentos/:id',
    exact: true,
    component: TipoDocumentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/tiposdocumentos/:id/view',
    exact: true,
    component: TipoDocumentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/contascorrentes',
    exact: true,
    component: ContaCorrenteList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
    authType: 'internal'
  },
  {
    path: '/financas/contascorrentes/:id',
    exact: true,
    component: ContaCorrenteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
    authType: 'internal'
  },
  {
    path: '/financas/contascorrentes/:id/view',
    exact: true,
    component: ContaCorrenteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE,
    authType: 'internal'
  },
  {
    path: '/financas/transacoes',
    exact: true,
    component: TransacaoFinanceiraList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_TRANSACAO_FINANCEIRA,
    authType: 'internal'
  },
  {
    path: '/financas/bancos',
    exact: true,
    component: BancoList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_BANCO,
    authType: 'internal'
  },
  {
    path: '/financas/setores',
    exact: true,
    component: SetorList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_SETOR,
    authType: 'internal'
  },
  {
    path: '/financas/feriados',
    exact: true,
    component: FeriadoList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_FERIADO,
    authType: 'internal'
  },
  {
    path: '/financas/paises',
    exact: true,
    component: PaisList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/financas/fechamentofinanceiro',
    exact: true,
    component: FechamentoFinanceiroForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_FINANCEIRO_FECHAMENTO,
    authType: 'internal'
  },
  {
    path: '/financas/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/financas/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/financas/usuario'
  },
  {
    path: '/financas/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/financas/usuario'
  },
  {
    path: '/financas/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/financas/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: PERMS.FINANCAS_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/financas/cliente'
  },

  // front
  {
    path: '/front',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/front/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/exportacao/snowland',
    exact: true,
    component: OrbitIntegration,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_WEB_SERVICE,
    authType: 'internal'
  },
  {
    path: '/front/oss',
    exact: true,
    component: OSList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/os/:id',
    component: OSForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/pax/:id',
    exact: true,
    component: FormPax,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/mapaoperacao', // não tem no desktop, terá somente no web
    exact: true,
    component: MapaOperacao,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos',
    exact: true,
    component: CategoriaServicoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos/:id',
    component: CategoriaServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA,
    authType: 'internal'
  },
  {
    path: '/front/servicos',
    exact: true,
    component: ServicoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/servicos/:id',
    component: ServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos',
    exact: true,
    component: MotivoCancelamentoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos/:id',
    component: MotivoCancelamentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO,
    authType: 'internal'
  },
  {
    path: '/front/vendedores',
    exact: true,
    component: VendedorList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VENDEDOR,
    authType: 'internal'
  },
  {
    path: '/front/vendedores/:id',
    component: VendedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VENDEDOR,
    authType: 'internal'
  },
  {
    path: '/front/clientes',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_CLIENTE_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo',
    exact: true,
    component: TipoVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/front/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/front/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/front/usuario'
  },
  {
    path: '/front/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/front/usuario'
  },
  {
    path: '/front/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_CLIENTE_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/front/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FRONT,
    requiredPerm: PERMS.FRONT_MENU_CADASTRO_CLIENTE_CLIENTE,
    authType: 'internal',
    redirectTo: '/front/cliente'
  },

  // frotas
  {
    path: '/frotas',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/frotas/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo',
    exact: true,
    component: VeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo/:id',
    component: VeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo',
    exact: true,
    component: MarcaVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo/:id',
    component: MarcaVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo',
    exact: true,
    component: ModeloVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo/:id',
    component: ModeloVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo',
    exact: true,
    component: TipoVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo',
    exact: true,
    component: OpcionalVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo/:id',
    component: OpcionalVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL,
    authType: 'internal'
  },
  {
    path: '/frotas/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/frotas/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/frotas/usuario'
  },
  {
    path: '/frotas/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/frotas/usuario'
  },
  {
    path: '/frotas/abastecimento',
    exact: true,
    component: AbastecimentoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR,
    authType: 'internal'
  },
  {
    path: '/frotas/abastecimento/:id',
    component: AbastecimentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo',
    exact: true,
    component: OsManutVeiculoList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo/:id',
    component: OsManutVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO,
    authType: 'internal'
  },
  {
    path: '/frotas/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    // requiredPerm: PERMS.FROTAS_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/frotas/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    // requiredPerm: PERMS.FROTAS_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/frotas/cliente'
  },

  // gerencial
  {
    path: '/gerencial',
    exact: true,
    component: Login,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/gerencial/dashboard',
    exact: true,
    component: Dashboard,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuproducao',
    exact: true,
    component: MenuProducao,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_PRODUCAO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuoperacional',
    exact: true,
    component: MenuOperacional,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_OPERACIONAL,
    authType: 'internal'
  },
  {
    path: '/gerencial/menufinanceiro',
    exact: true,
    component: MenuFinanceiro,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_FINANCEIRO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuadministrativo',
    exact: true,
    component: MenuAdministrativo,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_ADMINISTRATIVO,
    authType: 'internal'
  },
  {
    path: '/gerencial/orbit',
    exact: true,
    component: OrbitIntegration,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_WEB_SERVICE,
    authType: 'internal'
  },
  {
    path: '/gerencial/usuario',
    exact: true,
    component: UsuarioList,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_CADASTRO_USUARIO,
    authType: 'internal'
  },
  {
    path: '/gerencial/usuario/:id',
    exact: true,
    component: UsuarioForm,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/gerencial/usuario'
  },
  {
    path: '/gerencial/usuario/:id/permissoes',
    component: PermissoesForm,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_CADASTRO_USUARIO,
    authType: 'internal',
    redirectTo: '/gerencial/usuario'
  },
  {
    path: '/gerencial/cliente',
    exact: true,
    component: ClienteList,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    // requiredPerm: PERMS.GERENCIAL_MENU_CADASTRO_CLIENTE,
    authType: 'internal'
  },
  {
    path: '/gerencial/cliente/:id',
    component: ClienteForm,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    // requiredPerm: PERMS.GERENCIAL_MENU_CADASTRO_CLIENTE,
    authType: 'internal',
    redirectTo: '/gerencial/cliente'
  }
];

/* Define os itens de menu exibidos para cada módulo */
export const menuByModule = {
  // adm pdv movel
  [AMODULO_PDVMOVEL]: [
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/admpdvmovel/usuario',
          permCode: PERMS.ADMPDVMOVEL_MENU_CADASTRO_USUARIO
        }
      ]
    },
    {
      key: 'procedimentos',
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'solicitacoes-pdv',
          fallbackLabel: 'Solicitações PDV',
          icon: ForumOutlined,
          to: '/admpdvmovel/solicitacoes-pdv',
          permCode: PERMS.ADMPDVMOVEL_MENU_SOLICITACOES_PDV
        }
      ]
    },
    {
      key: 'configuracoes',
      fallbackLabel: 'Configurações',
      icon: SettingsApplicationsOutlined,
      children: [
        {
          key: 'configuracoes-geral',
          fallbackLabel: 'Geral',
          icon: SettingsApplicationsOutlined,
          to: '/admpdvmovel/configuracoes/geral',
          permCode: PERMS.ADMPDVMOVEL_MENU_CONFIGURACOES_GERAL
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // adm appcli
  [AMODULO_ADMAPPCLI]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/admappcli/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/admappcli/usuario',
          permCode: PERMS.ADMAPPCLI_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/admappcli/cliente',
          permCode: PERMS.ADMAPPCLI_MENU_CADASTRO_CLIENTE
        }
      ]
    },
    {
      key: 'passageiros',
      labelKey: CommonTranslations.MENU_PASSENGER,
      fallbackLabel: 'Passenger',
      icon: SupervisedUserCircleOutlined,
      children: [
        {
          key: 'adm-sisare-passenger-list',
          labelKey: CommonTranslations.MENU_ITEM_PASSAGEIRO,
          fallbackLabel: 'Passageiros',
          icon: PeopleOutline,
          to: '/admappcli/adm-sisare-passenger-list',
          permCode: PERMS.ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO
        },
        {
          key: 'adm-sisare-passenger-analytics',
          labelKey: CommonTranslations.MENU_ITEM_ANALYTICS,
          fallbackLabel: 'Analytics',
          icon: AssessmentOutlined,
          to: '/admappcli/adm-sisare-passenger-analytics',
          permCode: PERMS.ADMAPPCLI_MENU_PASSENGER_ANALYTIC
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // adm partner
  [AMODULO_PARTNER]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/admpartner/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'agenda',
          labelKey: CommonTranslations.MENU_ITEM_AGENDA_ESCALA,
          fallbackLabel: 'Agenda Escalas',
          icon: EventNoteOutlined,
          to: '/admpartner/agendaescalafornecedor',
          permCode: PERMS.ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA
        },
        {
          key: 'usuarios-partner',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO_PARTNER,
          fallbackLabel: 'Usuários Partner',
          icon: AccountCircleOutlined,
          to: '/admpartner/usuariopartner',
          permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER
        },
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/admpartner/usuario',
          permCode: PERMS.ADMPARTNER_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/admpartner/cliente',
          // permCode: PERMS.ADMPARTNER_MENU_CADASTRO_CLIENTE
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // crm
  [AMODULO_CRM]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/crm/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/crm/usuario',
          permCode: PERMS.CRM_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/crm/cliente',
          permCode: PERMS.CRM_MENU_CADASTRO_CLIENTE
        },
        {
          key: 'contatos',
          labelKey: CommonTranslations.MENU_ITEM_CONTATO_AVULSO,
          fallbackLabel: 'Contatos avulsos',
          icon: ContactsOutlined,
          to: '/crm/contato',
          //permCode: PERMS.CRM_MENU_CADASTRO_CONTATO_AVULSO
        },
        {
          key: 'gruposcontato',
          labelKey: CommonTranslations.MENU_ITEM_GRUPO_CONTATO_AVULSO,
          fallbackLabel: 'Grupos de contatos',
          icon: RecentActorsOutlined,
          to: '/crm/grupocontato',
          permCode: PERMS.CRM_MENU_CADASTRO_GRUPO_CONTATO_AVULSO
        },
        {
          key: 'canaisvenda',
          labelKey: CommonTranslations.MENU_ITEM_CANAL_VENDA,
          fallbackLabel: 'Canais de vendas',
          icon: Storefront,
          to: '/crm/canalvenda',
          permCode: PERMS.CRM_MENU_CADASTRO_CANAL_VENDA
        },
        {
          key: 'sac-root',
          labelKey: CommonTranslations.MENU_ITEM_SAC,
          fallbackLabel: 'SAC',
          icon: HeadsetMicOutlined,
          children: [
            {
              key: 'classificacoes-sac',
              labelKey: CommonTranslations.MENU_ITEM_CLASSIFICACAO_SAC,
              fallbackLabel: 'Classificações',
              icon: ViewWeekRounded,
              to: '/crm/classifatendimentosac',
              permCode: PERMS.CRM_MENU_CADASTRO_SAC_CLASSIFICACAO_ATENDIMENTO
            },
            {
              key: 'subclassificacoes-sac',
              labelKey: CommonTranslations.MENU_ITEM_SUBCLASSIFICACAO_SAC,
              fallbackLabel: 'Subclassificações',
              icon: ViewModuleRounded,
              to: '/crm/subclassifatendimentosac',
              permCode: PERMS.CRM_MENU_CADASTRO_SAC_SUBCLASSIFICACAO_ATENDIMENTO
            }
          ]
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: CommonTranslations.MENU_PROCEDIMENTOS,
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'followup',
          labelKey: CommonTranslations.MENU_ITEM_FOLLOW_UP,
          fallbackLabel: 'Follow up',
          icon: PlaylistAddCheckRounded,
          to: '/crm/followup',
          permCode: PERMS.CRM_MENU_PROCEDIMENTOS_FOLLOW_UP
        },
        {
          key: 'atendimento-sac',
          labelKey: CommonTranslations.MENU_ITEM_ATENDIMENTO_SAC,
          fallbackLabel: 'Atendimento SAC',
          icon: HeadsetMicOutlined,
          to: '/crm/atendimentosac',
          permCode: PERMS.CRM_MENU_PROCEDIMENTOS_ATENDIMENTO_SAC
        },
        {
          key: 'whatsapp',
          labelKey: CommonTranslations.MENU_ITEM_WHATSAPP,
          fallbackLabel: 'WhatsApp',
          icon: WhatsApp,
          children: [
            {
              key: 'grupos-msg-whatsapp',
              labelKey: CommonTranslations.MENU_ITEM_WHATSAPP_GRUPO_MENSAGEM,
              fallbackLabel: 'Grupos Mensagens',
              icon: ForumOutlined,
              to: '/crm/grupomsgwhatsappfornecedor',
              permCode: 0
            },
            {
              key: 'msg-whatsapp',
              labelKey: CommonTranslations.MENU_ITEM_WHATSAPP_MENSAGEM,
              fallbackLabel: 'Mensagens',
              icon: MessageOutlined,
              to: '/crm/msgwhatsappfornecedor',
              permCode: PERMS.CRM_MENU_PROCEDIMENTOS_WHATSAPP_MONITOR_MENSAGEM
            },
            {
              key: 'envio-whatsapp',
              labelKey: CommonTranslations.MENU_ITEM_WHATSAPP_ENVIO,
              fallbackLabel: 'Envio',
              icon: Send,
              to: '/crm/enviowhatsappfornecedor',
              permCode: PERMS.CRM_MENU_PROCEDIMENTOS_WHATSAPP_ENVIO
            },
            {
              key: 'chat-whatsapp',
              labelKey: CommonTranslations.MENU_ITEM_WHATSAPP_CHAT,
              fallbackLabel: 'Chat',
              icon: ChatBubbleOutlineOutlined,
              to: '/crm/chatwhatsapp',
              permCode: 0
            }
          ]
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // estoque
  [AMODULO_ESTOQUE]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/estoque/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/estoque/usuario',
          permCode: PERMS.ESTOQUE_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/estoque/cliente',
          // permCode: PERMS.ESTOQUE_MENU_CADASTRO_CLIENTE
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // finanças
  [AMODULO_FINANCAS]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/financas/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'historicos-bancarios',
          labelKey: CommonTranslations.MENU_ITEM_HISTORICO_BANCARIO,
          fallbackLabel: 'Históricos Bancários',
          icon: InsertDriveFileOutlined,
          to: '/financas/historicosbancarios',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO
        },
        {
          key: 'tipos-documentos',
          labelKey: CommonTranslations.MENU_ITEM_TIPO_DOCUMENTO,
          fallbackLabel: 'Tipos Documentos',
          icon: DescriptionOutlined,
          to: '/financas/tiposdocumentos',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO
        },
        {
          key: 'contas-correntes',
          labelKey: CommonTranslations.MENU_ITEM_CONTA_CORRENTE,
          fallbackLabel: 'Contas Correntes',
          icon: TrendingUpRounded,
          to: '/financas/contascorrentes',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_CONTA_CORRENTE
        },
        {
          key: 'transacoes',
          labelKey: CommonTranslations.MENU_ITEM_TRANSACAO,
          fallbackLabel: 'Transações',
          icon: ReceiptOutlined,
          to: '/financas/transacoes',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_TRANSACAO_FINANCEIRA
        },
        {
          key: 'bancos',
          labelKey: CommonTranslations.MENU_ITEM_BANCO,
          fallbackLabel: 'Bancos',
          icon: AccountBalanceOutlined,
          to: '/financas/bancos',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_BANCO
        },
        {
          key: 'setores',
          labelKey: CommonTranslations.MENU_ITEM_SETOR,
          fallbackLabel: 'Setores',
          icon: AccountTreeOutlined,
          to: '/financas/setores',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_SETOR
        },
        {
          key: 'feriados',
          labelKey: CommonTranslations.MENU_ITEM_FERIADO,
          fallbackLabel: 'Feriados',
          icon: EventOutlined,
          to: '/financas/feriados',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_FERIADO
        },
        {
          key: 'paises',
          labelKey: CommonTranslations.MENU_ITEM_PAIS,
          fallbackLabel: 'Países',
          icon: Public,
          to: '/financas/paises',
          permCode: 0
        },
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/financas/usuario',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/financas/cliente',
          permCode: PERMS.FINANCAS_MENU_CADASTRO_CLIENTE
        }
      ]
    },
    {
      key: 'fechamento-financeiro',
      labelKey: CommonTranslations.MENU_FECHAMENTO_FINANCEIRO,
      fallbackLabel: 'Fechamento Financeiro',
      icon: MonetizationOnOutlined,
      children: [
        {
          key: 'executar-fechamento',
          labelKey: CommonTranslations.MENU_ITEM_EXECUTAR_FECHAMENTO,
          fallbackLabel: 'Executar',
          icon: AssignmentTurnedInOutlined,
          to: '/financas/fechamentofinanceiro',
          permCode: PERMS.FINANCAS_MENU_FINANCEIRO_FECHAMENTO
        },
        {
          key: 'historico-fechamentos',
          labelKey: CommonTranslations.MENU_ITEM_HISTORICO_FECHAMENTO,
          fallbackLabel: 'Histórico Fechamentos',
          icon: Timeline,
          to: '/financas/fechamentosfinanceiros',
          permCode: 0
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // front
  [AMODULO_FRONT]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/front/dashboard',
      permCode: 0
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'servicos-root',
          labelKey: CommonTranslations.MENU_ITEM_SERVICO,
          fallbackLabel: 'Serviços',
          icon: BuildOutlined,
          children: [
            {
              key: 'categorias-servicos',
              labelKey: CommonTranslations.MENU_ITEM_CATEGORIA_SERVICO,
              fallbackLabel: 'Categorias',
              icon: CategoryOutlined,
              to: '/front/categoriasservicos',
              permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_CATEGORIA
            },
            {
              key: 'servicos',
              labelKey: CommonTranslations.MENU_ITEM_SERVICO,
              fallbackLabel: 'Serviços',
              icon: BuildOutlined,
              to: '/front/servicos',
              permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_SERVICO
            },
            {
              key: 'motivos-cancelamentos',
              labelKey: CommonTranslations.MENU_ITEM_MOTIVO_CANCELAMENTO,
              fallbackLabel: 'Motivos Cancelamento',
              icon: TextsmsOutlined,
              to: '/front/motivoscancelamentos',
              permCode: PERMS.FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO
            }
          ]
        },
        {
          key: 'veiculos-root',
          labelKey: CommonTranslations.MENU_ITEM_VEICULO,
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlined,
          children: [
            {
              key: 'tipos-veiculos',
              labelKey: CommonTranslations.MENU_ITEM_TIPO_VEICULO,
              fallbackLabel: 'Tipos',
              icon: WidgetsOutlined,
              to: '/front/tipoveiculo',
              permCode: PERMS.FRONT_MENU_CADASTRO_VEICULO_TIPO
            }
          ]
        },
        {
          key: 'clientes-root',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          children: [
            {
              key: 'clientes',
              labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
              fallbackLabel: 'Clientes',
              icon: PeopleOutline,
              to: '/front/cliente',
              permCode: PERMS.FRONT_MENU_CADASTRO_CLIENTE_CLIENTE
            }
          ]
        },
        {
          key: 'vendedores',
          labelKey: CommonTranslations.MENU_ITEM_VENDEDOR,
          fallbackLabel: 'Vendedores',
          icon: AssignmentIndOutlined,
          to: '/front/vendedores',
          permCode: PERMS.FRONT_MENU_CADASTRO_VENDEDOR
        },
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/front/usuario',
          permCode: PERMS.FRONT_MENU_CADASTRO_USUARIO
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: CommonTranslations.MENU_PROCEDIMENTOS,
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'oss',
          labelKey: CommonTranslations.MENU_ITEM_ORDEM_SERVICO,
          fallbackLabel: 'Ordens Serviço',
          to: '/front/oss',
          icon: AssignmentOutlined,
          permCode: PERMS.FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO
        }
      ]
    },
    {
      key: 'opcoes',
      labelKey: CommonTranslations.MENU_OPCOES,
      fallbackLabel: 'Opções',
      icon: SettingsApplicationsOutlined,
      children: [
        {
          key: 'exportacao',
          labelKey: CommonTranslations.MENU_ITEM_EXPORTACAO,
          fallbackLabel: 'Exportações',
          icon: AssignmentTurnedInOutlined,
          children: [
            {
              key: 'snowland',
              labelKey: CommonTranslations.MENU_ITEM_SNOWLAND,
              fallbackLabel: 'Snowland',
              icon: Send,
              to: '/front/exportacao/snowland',
              permCode: PERMS.FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_WEB_SERVICE
            }
          ]
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // frotas
  [AMODULO_FROTAS]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/frotas/dashboard'
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'veiculos-root',
          labelKey: CommonTranslations.MENU_ITEM_VEICULO,
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlined,
          children: [
            {
              key: 'tipos',
              labelKey: CommonTranslations.MENU_ITEM_TIPO_VEICULO,
              fallbackLabel: 'Tipos',
              icon: WidgetsOutlined,
              to: '/frotas/tipoveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_TIPO
            },
            {
              key: 'veiculos',
              labelKey: CommonTranslations.MENU_ITEM_VEICULO,
              fallbackLabel: 'Veículos',
              icon: DriveEtaOutlined,
              to: '/frotas/veiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_VEICULO
            },
            {
              key: 'marcas',
              labelKey: CommonTranslations.MENU_ITEM_MARCA_VEICULO,
              fallbackLabel: 'Marcas',
              icon: Commute,
              to: '/frotas/marcaveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MARCA
            },
            {
              key: 'modelos',
              labelKey: CommonTranslations.MENU_ITEM_MODELO_VEICULO,
              fallbackLabel: 'Modelos',
              icon: EmojiTransportation,
              to: '/frotas/modeloveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_MODELO
            },
            {
              key: 'opcionais',
              labelKey: CommonTranslations.MENU_ITEM_OPCIONAL_VEICULO,
              fallbackLabel: 'Opcionais',
              icon: Grain,
              to: '/frotas/opcionalveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL
            }
          ]
        },
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/frotas/usuario',
          permCode: PERMS.FROTAS_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/frotas/cliente',
          // permCode: PERMS.FROTAS_MENU_CADASTRO_CLIENTE
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: CommonTranslations.MENU_PROCEDIMENTOS,
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'abastecimentos-root',
          labelKey: CommonTranslations.MENU_ITEM_ABASTECIMENTO,
          fallbackLabel: 'Abastecimentos',
          icon: LocalGasStationOutlined,
          children: [
            {
              key: 'lancar-abastecimentos',
              labelKey: CommonTranslations.MENU_ITEM_ABASTECIMENTO_LANCAR,
              fallbackLabel: 'Lançar',
              icon: QueueOutlined,
              to: '/frotas/abastecimento',
              permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR
            }
          ]
        },
        {
          key: 'oss-manutencao',
          labelKey: CommonTranslations.MENU_ITEM_ORDEM_SERVICO_MANUTENCAO,
          fallbackLabel: 'OS Manutenção',
          icon: AssignmentOutlined,
          to: '/frotas/osmanutveiculo',
          permCode: PERMS.FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ],

  // gerencial
  [AMODULO_GERENCIAL]: [
    {
      key: 'dashboard',
      labelKey: CommonTranslations.MENU_DASHBOARD,
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlined,
      to: '/gerencial/dashboard'
    },
    {
      key: 'cadastro',
      labelKey: CommonTranslations.MENU_CADASTRO,
      fallbackLabel: 'Cadastro',
      icon: PostAddRounded,
      children: [
        {
          key: 'usuarios',
          labelKey: CommonTranslations.MENU_ITEM_USUARIO,
          fallbackLabel: 'Usuários',
          icon: PersonOutlined,
          to: '/gerencial/usuario',
          permCode: PERMS.GERENCIAL_MENU_CADASTRO_USUARIO
        },
        {
          key: 'clientes',
          labelKey: CommonTranslations.MENU_ITEM_CLIENTE,
          fallbackLabel: 'Clientes',
          icon: PeopleOutline,
          to: '/gerencial/cliente',
          // permCode: PERMS.GERENCIAL_MENU_CADASTRO_CLIENTE
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: CommonTranslations.MENU_PROCEDIMENTOS,
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRounded,
      children: [
        {
          key: 'producao',
          labelKey: CommonTranslations.MENU_ITEM_PRODUCAO,
          fallbackLabel: 'Produção',
          icon: TrendingUpRounded,
          to: '/gerencial/menuproducao',
          permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_PRODUCAO
        },
        {
          key: 'operacional',
          labelKey: CommonTranslations.MENU_ITEM_OPERACIONAL,
          fallbackLabel: 'Operacional',
          icon: SettingsApplicationsOutlined,
          to: '/gerencial/menuoperacional',
          permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_OPERACIONAL
        },
        {
          key: 'financeiro',
          labelKey: CommonTranslations.MENU_ITEM_FINANCEIRO,
          fallbackLabel: 'Financeiro',
          icon: MonetizationOnOutlined,
          to: '/gerencial/menufinanceiro',
          permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_FINANCEIRO
        },
        {
          key: 'administrativo',
          labelKey: CommonTranslations.MENU_ITEM_ADMINISTRATIVO,
          fallbackLabel: 'Administrativo',
          icon: PermContactCalendarOutlined,
          to: '/gerencial/menuadministrativo',
          permCode: PERMS.GERENCIAL_MENU_PROCEDIMENTOS_ADMINISTRATIVO
        }
      ]
    },
    {
      key: 'logout',
      labelKey: CommonTranslations.MENU_SAIR,
      fallbackLabel: 'Sair',
      icon: ExitToAppRounded,
      to: '/logout'
    }
  ]
};

/* Helpers opcionais */
// filtra as rotas pertencentes a um módulo específico
export const getRoutesByModule = (moduleCode) => {
  appRoutes.filter(route => route.moduleCode === moduleCode);
};

// retorna os itens de menu de um módulo específico
export const getMenuByModule = (moduleCode) => {
  menuByModule[moduleCode] || [];
};